import { providerColors, theme } from '../theme';

export const resolveProviderKey = (name: string): string => {
  const n = name.toLowerCase();
  if (n.includes("aws") && n.includes("esc")) return "AWS ESC";
  if (n.includes("aws") && n.includes("commercial")) return "AWS Commercial";
  if (n.includes("aws")) return "AWS";
  if (n.includes("delos")) return "DELOS";
  if (n.includes("azure") && n.includes("commercial")) return "Azure Commercial";
  if (n.includes("microsoft") || n.includes("azure") || n.includes("msft")) return "Microsoft";
  if (n.includes("google") || n.includes("gcp") || n.includes("t-systems") || n.includes("tsystems")) return "Google";
  if (n.includes("stackit")) return "StackIT";
  if (n.includes("plusserver") || n.includes("plus-server")) return "Plusserver";
  if (n.includes("ibm")) return "IBM";
  if (n.includes("ovh")) return "OVH";
  if (n.includes("ionos")) return "IONOS";
  return name;
};

export const getProviderColor = (name: string): string =>
  providerColors[resolveProviderKey(name)] ?? theme.bar;

export const displayProviderName = (name: string): string => {
  // Return full name — no shortening, so Commercial vs Sovereign variants are distinguishable
  return name;
};

export const isHyperscaler = (name: string): boolean => {
  const key = resolveProviderKey(name);
  return ['AWS', 'Microsoft', 'Google'].includes(key);
};
